import { createStore, combineReducers, applyMiddleware, compose } from "redux";
import thunk from "redux-thunk";
import promise from "redux-promise-middleware";
import globalReducer from "./reducers/globalReducer";
import rawDataReducer from "./reducers/rawDataReducer";
import searchDataReducer from "./reducers/searchDataReducer";
import toastReducer from "./reducers/toastReducer";
import csvDownloadReducer from "./reducers/csvDownloadReducer";
import refineFilterReducer from "./reducers/refineFiltersReducer";
import wordCloudReducer from "./reducers/wordCloudReducer";
import fbInsightsReducer from "./reducers/fbInsightsReducer";
import viralityDataReducer from "./reducers/viralityDataReducer";
import collectionsReducer from "./reducers/collectionsReducer";
import trendsReducer from "./reducers/trendsReducer";
import reportsAndAlertsReducer from "./reducers/reportsAndAlertsReducer";
import downloadsReducer from "./reducers/downloadsReducer";
import publicationsReducer from "./reducers/publicationsReducer";
import userManagementReducer from "./reducers/userManagementReducer";
import tokensReducer from "./reducers/tokensReducer";
import spamsReducer from "./reducers/spamsReducer";
import fbCommentsReducer from "./reducers/facebookCommentsReducer";
import instagramHashTagReducer from "./reducers/instagramHashTagReducer";
import filterSettingReducer from "./reducers/filterSettingReducer";
import blocksourceReducer from "./reducers/blocksourceReducer";
import loginlogsReducer from "./reducers/loginLogsReducer";
import authReducer from "./reducers/authReducer";
import dashboardReducer from "./reducers/dashboardReducer";
import queryBuilderReducer from "./reducers/queryBuilderReducer";
import historicDataReducer from "./reducers/historicDataReducer";
import socialResponseReducer from "./reducers/socialResponseReducer";
import intagramInsightsReducers from "./reducers/instagramInsightsReducers";
import tiktokInsightsReducers from "./reducers/tiktokInsightsReducers";
import twitterInsightsReducer from "./reducers/twitterInsightsReducer";
import SMRAnalyticsReducer from "./reducers/SMRAnalyticsReducer";
import competitorInsightsReducer from "./reducers/competitorInsightsReducer";
import cannedResponseReducer from "./reducers/smrCannedResponseReducer";
import SMRRuleReducer from "./reducers/SMRRuleReducer";
import SMPReducer from "./reducers/SMPReducer";
import sidebarReducer from "./reducers/sidebarReducer";
import linkedinInsightsReducers from "./reducers/linkedinInsightsReducers";
import userActivityLogsReducer from "./reducers/userActivityLogsReducer";
import facebookPagesModalReducer from "./reducers/facebookPagesModalReducer";
// import globalEpic from "./epics";

// const epicMiddleware = createEpicMiddleware();
import subscriptionReducer from "./reducers/subscriptionReducer";
import SMPAnalyticsReducer from "./reducers/SMPAnalyticsReducer";
import youtubeInsightsReducers from "./reducers/youtubeInsightsReducers";
import SMRSurveyReducer from "./reducers/SMRSurveyReducer";
import dataUsageReducer from "./reducers/dataUsageReducer";
import advCustomChartReducer from "./reducers/advCustomChartReducer";
import insightsRecommendationReducer from "./reducers/insightsRecommendationReducer";
import SMRCommentFilterReducer from "./reducers/SMRCommentFilterReducer";
import automationEngineReducer from "./reducers/automationEngineReducer";
import smrReportsReducer from "./reducers/smrReportsReducer";
import keywordSyncedPostsReducer from "./reducers/keywordSyncedPostsReducer";

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const appReducer = combineReducers({
    globalReducer,
    sidebarReducer,
    rawDataReducer,
    searchDataReducer,
    csvDownloadReducer,
    toastReducer,
    refineFilterReducer,
    wordCloudReducer,
    fbInsightsReducer,
    viralityDataReducer,
    collectionsReducer,
    trendsReducer,
    reportsAndAlertsReducer,
    downloadsReducer,
    publicationsReducer,
    userManagementReducer,
    tokensReducer,
    spamsReducer,
    fbCommentsReducer,
    instagramHashTagReducer,
    filterSettingReducer,
    blocksourceReducer,
    loginlogsReducer,
    authReducer,
    dashboardReducer,
    queryBuilderReducer,
    historicDataReducer,
    socialResponseReducer,
    subscriptionReducer,
    intagramInsightsReducers,
    tiktokInsightsReducers,
    twitterInsightsReducer,
    linkedinInsightsReducers,
    youtubeInsightsReducers,
    SMRAnalyticsReducer,
    competitorInsightsReducer,
    cannedResponseReducer,
    SMPReducer,
    SMRRuleReducer,
    userActivityLogsReducer,
    SMPAnalyticsReducer,
    SMRSurveyReducer,
    dataUsageReducer,
    advCustomChartReducer,
    insightsRecommendationReducer,
    smrReportsReducer,
    SMRCommentFilterReducer,
    automationEngineReducer,
    keywordSyncedPostsReducer,
    facebookPagesModalReducer
});

const rootReducer = (state, action) => {
    if (action.type === "USER_LOGOUT") {
        return appReducer(undefined, action);
    }

    return appReducer(state, action);
};

export default createStore(
    rootReducer,
    // composeEnhancers(applyMiddleware(thunk, promise, epicMiddleware.run(globalEpic)))
    composeEnhancers(applyMiddleware(thunk, promise)),
);
